export enum RegistrationCommodityErrorWarningType {
  ClaimAmountMismatch = 'claimAmountMismatch',
  ClassNMFCMismatch = 'classNMFCMismatch',
}
